<div id="dialog-container">
  <h1 mat-dialog-title>{{ 'TITLE.ADD_INVESTMENT' | translate }}</h1>

  <mat-divider></mat-divider>

  @if (missingRequiredFields.length > 0) {
    <mat-dialog-content class="creation-dialog-no-stepper fx-flex-auto">
      <span>{{ 'MESSAGE.INSUFFICIENT_FIELDS_PERMISSIONS' | translate }}</span>
      <ul>
        @for (field of missingRequiredFields; track field.code) {
          <li>{{ field.label }}</li>
        }
      </ul>
    </mat-dialog-content>
    <mat-dialog-actions class="center">
      <button mat-raised-button matDialogClose="cancel" color="accent" id="dialog-cancel-button">
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </mat-dialog-actions>
  } @else {
    <mat-dialog-content class="creation-dialog-no-stepper fx-flex-auto">
      <div class="form-container">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'LABEL.NAME' | translate }}</mat-label>
          <input matInput id="create_investment_provider" [formControl]="nameForm" required/>
          @if (nameForm.hasError('required')) {
            <mat-error>
              {{ 'ERROR.FIELD_REQUIRED' | translate }}
            </mat-error>
          }
          @if (nameForm.hasError('maxlength')) {
            <mat-error>
              {{ 'ERROR.FIELD_MAX_LENGTH' | translate: {value: appConfig.FIELD_MAX_LENGTH} }}
            </mat-error>
          }
        </mat-form-field>

        <div class="button-container fx-layout-row fx-justify-end fx-align-center">
          <button mat-stroked-button matDialogClose="cancel" id="cancel-button">
            {{ 'BUTTON.CANCEL' | translate }}
          </button>
          <button [disabled]="!nameForm.valid"
                  id="add-button"
                  color="accent"
                  mat-raised-button
                  matDialogClose="yes">
            {{ 'BUTTON.ADD' | translate }}
          </button>
        </div>
      </div>
    </mat-dialog-content>
  }
</div>
